<template>
    <ClientOnly>
        <LazyPortfolioItemOverlay v-if="portfolioRevampEnabled && portfolioItemId" :portfolio-item-id="portfolioItemId" />
    </ClientOnly>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {ClientOnly, LazyPortfolioItemOverlay} from '#components';
    import {useRoute} from '#imports';
    import {useFeatureFlag} from '@malt/feature-flags';
    import {useProfilePageViewMode} from '~/composables/useProfilePageViewMode';
    import {anchorsPageProfile} from '~/config/anchors';

    const portfolioRevampV1 = useFeatureFlag('portfolio-revamp-v1');
    const workshopAiNantesPortfolioRevamp = useFeatureFlag('workshop-ai-nantes-portfolio-revamp');
    const {isEditionEnabled} = useProfilePageViewMode();

    const portfolioRevampEnabled = computed(() => portfolioRevampV1.value || (workshopAiNantesPortfolioRevamp.value && isEditionEnabled.value));

    const route = useRoute();
    const portfolioItemId = computed(() => {
        const hash = route.hash.startsWith('#') ? route.hash.slice(1) : route.hash;
        const prefix = anchorsPageProfile.portfolioItemById('');
        if (!hash.startsWith(prefix)) {
            return undefined;
        }
        const id = hash.slice(prefix.length);
        return id || undefined;
    });
</script>
